module.exports = __webpack_public_path__ + "static/media/ost_8.26628f54.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/ost_8.png
// module id = 1046
// module chunks = 0